<template>

    <div class="col-lg-4 col-lg-offset-1 col-md-6 col-sm-12">

        <h2>
            Dokumenter
        </h2>

        <p style="margin-bottom:40px">
            <!--Tekst kommer snart-->
        </p>

        <div class="row">

            <document
                title="Kontrolrapport"
                issuer="Fødevarestyrelsen"
                link="/static/images/kontrolrapport.pdf"
            />

        </div>

    </div>

</template>

<script>
import Document from './document.vue'

export default {
    components: {
        Document
    }
}
</script>




// WEBPACK FOOTER //
// documents.vue?bac235ba